import { User } from 'api'
import { withErrorBoundary } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { useState } from 'react'

const ChangePasswordPage = () => {
  const [state, setState] = useState({ password: '', passwordConfirmation: '', error: null });

  const changePassword = async () => {
    const { password, passwordConfirmation } = state;

    if (_.isEmpty(password)) {
      setState({ ...state, error: 'Please enter a new password!' });
    } else if (password !== passwordConfirmation) {
      setState({ ...state, error: 'Passwords do not match!' });
    } else {
      try {
        const res = await Backend.put('/profile/password', { password });
        console.info('password change result', res);
        User.resetPasswordChangeFlag();
        setState({ ...state, error: null });
        window.location = '/app';
      } catch (xhr) {
        if (xhr.status >= 400 && xhr.status < 500) {
          setState({ ...state, error: xhr.responseJSON.message });
        }
      }
    }
  };

  const cancel = () => {
    User.resetPasswordChangeFlag();
    App.go('home');
  };

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value, error: null });
  };

  return (
    <div className="ChangePassword row justify-content-center">
      <div className="col-md-6">
        <h3 className="section-heading">Change Temporary Password</h3>

        <form>
          <div className="labeled-inline-field">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="****"
              autoComplete="new-password"
              name="password"
              value={state.password}
              onChange={inputChanged}
            />
          </div>
          <div className="labeled-inline-field">
            <label>New Password Confirmation</label>
            <input
              type="password"
              className="form-control"
              placeholder="****"
              autoComplete="new-password"
              name="passwordConfirmation"
              value={state.passwordConfirmation}
              onChange={inputChanged}
            />
          </div>

          <input type="hidden" autoComplete="username" name="username" value={User.current.email} />
        </form>

        {state.error && <p className="alert alert-danger text-center">{state.error}</p>}

        <div className="text-center">
          <SmartButtonStub text="Change Password" buttonType="button" className="my-2 admin-purple px-5 inverted primary" click={changePassword} />
          <SmartButtonStub click={cancel} text="Use Existing" />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(ChangePasswordPage);
